export const ENV_NAME = process.env.REACT_APP_ENV || process.env.NODE_ENV;
export const DEV_BUILD = ENV_NAME === 'dev';
export const VERSION = process.env.REACT_APP_VERSION || 'unknown';

export const PUBLIC_URL = process.env.PUBLIC_URL || '/';
export const S4P_BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'https://creator.wg.spotify.com/s4p-service';
export const S4P_AUTH_TOKEN_URL =
  process.env.REACT_APP_AUTH_TOKEN_URL ||
  'https://creator.wg.spotify.com/s4p-service/v3/auth/token';
export const S4P_AUTH_AUTH_CLIENT_ID =
  process.env.REACT_APP_AUTH_CLIENT_ID || '8fbd050ca47f430292682d30683d9c7c';
